import "@fontsource/noto-sans-tc/200.css"
import "@fontsource/noto-sans-tc/300.css"
import "@fontsource/noto-sans-tc/400.css"
import "@fontsource/noto-sans-tc/500.css"
import "@fontsource/noto-sans-tc/600.css"
import "@fontsource/noto-sans-tc/700.css"
import "@fontsource/noto-sans-tc/900.css"
import "@fontsource/roboto/200.css"
import "@fontsource/roboto/300.css"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/600.css"
import "@fontsource/roboto/700.css"
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';
import AOS from 'aos';
import 'aos/dist/aos.css';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

// JavaScript
$(document).ready( function () {
  AOS.init({
    once: true,
  });
  //scroll top
  $('.back-to-top').on('click', function(e){
    $("html,body").animate({scrollTop: 0}, 100);
  });

  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
  });

  $('.menu-link').click(function(e) {
      $(this).parent().toggleClass('active').siblings().removeClass('active');
  });

  const indexVideoSwiper = new Swiper('#indexVideoSwiper', {
    loop: false,
    speed: 500,
    navigation: {
      nextEl: ".swiper-buttons .swiper-button-next",
      prevEl: ".swiper-buttons .swiper-button-prev",
    },
  });

  // dropdown
  $('.dropdown-btn').on('click', function () {
    const id = $(this).attr('id');
    const dropdown_is_active = $('[aria-labelledby=' + id + ']').hasClass("is-active");
    if (dropdown_is_active >= 1) {
      $('[aria-labelledby=' + id + ']').removeClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '',
          'overflow': '',
        })
      }
    } else {
      $(".dropdown-list:not([aria-labelledby=" + id + "]").removeClass('is-active');
      $('[aria-labelledby=' + id + ']').addClass('is-active');
      if (window.innerWidth <= 640) {
        $('body').css({
          'height': '100vh',
          'overflow': 'hidden',
        })
      }
    }
  });

  $(document).click(function (event) {
    if (!$(event.target).closest('.dropdown-btn').length) {
      if ($('.dropdown-list').is(":visible")) {
        $(".dropdown-list").removeClass('is-active');
        if (window.innerWidth <= 640) {
          $('body').css({
            'height': '',
            'overflow': '',
          })
        }
      }
    }
  });

  // Dashboard Countup
  $(".dashboard-count").each(function () {
    let $el = $(this);
    let target = parseInt($el.text(), 10); // 原始數字
    let count = 0;
    let step = Math.ceil(target / 50); // 分成大約50步跑完

    $el.text(0); // 初始化
    let timer = setInterval(function () {
      count += step;
      if (count >= target) {
        $el.text(target); // 結束時補上精準值
        clearInterval(timer);
      } else {
        $el.text(count);
      }
    }, 30); // 每30毫秒更新一次
  });

  // 首頁精選客戶輪播 grid
  const clientsSwiper = new Swiper("#clientsSwiper", {
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-buttons .swiper-button-next",
      prevEl: ".swiper-buttons .swiper-button-prev",
    },
  });

  $('.footer-menu-link a').each(function() {
    var $link = $(this);
    var href = $link.attr('href');

    // 判斷 href 是否包含 /contact
    if (href && href.indexOf('/contact') !== -1) {
      // 為父層 li 添加 contact class
      $link.closest('.footer-menu-link').addClass('contact');
      $link.addClass('btn-more');
    }
  });

  const articleSwiper = new Swiper('#articleSwiper', {
    slidesPerView: 1.3,
    spaceBetween: 16,
    breakpoints: {
      640: {
        slidesPerView: 2.3,
        spaceBetween: 18,
      },
      800: {
        slidesPerView: 3.3,
        spaceBetween: 22,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 28,
      }
    }
  });

  // float-btn
  /*
  ============【 客戶預設 float btn 維持展開 】===========
  var $floatBtns = $('.float-btns');
  var $staticBtn = $floatBtns.find('.float-btn.static');

  // 桌面：滑鼠移入/移出
  $floatBtns.hover(
    function() { $floatBtns.addClass('active'); },
    function() { $floatBtns.removeClass('active'); }
  );

  // 判斷是否手機版
  function isMobile() {
    return $(window).width() < 800;
  }

  // 手機：點擊 static 按鈕切換 active
  if (isMobile()) {
    $staticBtn.on('touchstart click', function(e) {
      if (!$floatBtns.hasClass('active')) {
        e.preventDefault();   // 阻止 a 標籤跳轉
        $floatBtns.addClass('active'); // 顯示浮動按鈕
      }
      // 如果已經 active，就不阻止，允許跳轉
    });

    // 點擊外部區域取消 active
    $(document).on('touchstart click', function(e) {
      if (!$(e.target).closest('.float-btns').length) {
        $floatBtns.removeClass('active');
      }
    });
  }
  */

  const dropdownSelect = $('.dropdown-select');

  // 點擊按鈕切換 dropdown
  dropdownSelect.find('.dropdown-btn').on('click', function(e) {
    e.stopPropagation();
    const parent = $(this).closest('.dropdown-select');
    dropdownSelect.not(parent).removeClass('active').attr('aria-expanded', 'false');
    parent.toggleClass('active');
    parent.attr('aria-expanded', parent.hasClass('active'));
  });

  // 點擊選項
  dropdownSelect.find('.dropdown-item').on('click', function(e) {
    e.stopPropagation();
    const parent = $(this).closest('.dropdown-select');
    const btnText = parent.find('.dropdown-btn .dropdown-text');

    if ($(this).hasClass('disabled')) {
      parent.removeClass('active').attr('aria-expanded', 'false');
      return;
    }

    btnText.text($(this).text());
    parent.find('.dropdown-item').attr('aria-selected', 'false');
    $(this).attr('aria-selected', 'true');

    parent.removeClass('active').attr('aria-expanded', 'false');
  });

  // 點擊外部區域收合所有 dropdown
  $(document).on('click', function() {
    dropdownSelect.removeClass('active').attr('aria-expanded', 'false');
  });

  // 律師內頁 - simple_format 轉 無序清單
  $('.expertise-list').each(function() {
    const $p = $(this);
    const html = $(this).html().trim();

    // 把 <br> 分割成陣列
    const items = html.split(/<br\s*\/?>/i).map(item => item.trim()).filter(item => item.length > 0);

    const $ul = $('<ul class="expertise-list"></ul>');
    items.forEach(text => {
      $ul.append($('<li class="expertise-item"></li>').text(text));
    });

    // 用新的 <ul> 替換原本的 <p>
    $p.replaceWith($ul);
  });

  // 下載專區 - Add title attritube
  const downloadNames = $('.download-list .download-item .download-item-name');

  downloadNames.each(function(){
    $(this).attr('title', $(this).text());
  })
});

